import { render, staticRenderFns } from "./NavbarMenuLink.vue?vue&type=template&id=6ce1d020&"
import script from "./NavbarMenuLink.vue?vue&type=script&lang=js&"
export * from "./NavbarMenuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports